export function strokesToParDelta(par: number, strokes: number | null | undefined): {
  label: string;
  className: string;
} {
  if (strokes == null) return { label: '—', className: 'delta delta-par' };
  const diff = strokes - par;
  if (diff <= -2) return { label: String(diff), className: 'delta delta-eagle' };
  if (diff === -1) return { label: '-1', className: 'delta delta-birdie' };
  if (diff === 0) return { label: 'E', className: 'delta delta-par' };
  if (diff === 1) return { label: '+1', className: 'delta delta-bogey' };
  return { label: `+${diff}`, className: 'delta delta-double' };
}

export function buildShareUrl(shortCode: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}/join/${shortCode}`;
}
